<div class="row">
  <div class="col-sm-12 col-md-6 col-md-offset-3">
    <div *ngIf="reviewComponentSuccessMessage ?.length > 0">
      <div class="alert valign-children-middle">
        <div class="alert-success">
          <i aria-hidden="true" class="icon-approval"></i>
        </div>
        <div>
          <h2>Success</h2>
          <h2>{{reviewComponentSuccessMessage}}</h2>
        </div>
      </div>
    </div>
    <h2>Add multiple users</h2>
    <div class="form-group">
      <div class="col-sm-12 col-md-6">
        <label aria-label="Add multiple users" class="radio">
        <input name="actionType" type="radio" [checked]="addRadio" (click)="continueButton('add')"/><i class="skin"></i>
        <span>Add multiple users</span>
        </label>
      </div>
    </div>
    <div class="user-information">
      <p><label class="data-label">Before you begin</label></p>
      <p>Download a template to create a list of users to add.</p>
      <table>
        <tbody>
          <tr>
            <td>Add users (Excel template)</td>
            <td><a aria-label="Download Excel template" href="assets/download/Add_Users_XLSX.xlsx">Download</a></td>
          </tr>
          <tr>
            <td>Add users (CSV template)</td>
            <td><a aria-label="Download CSV template" href="assets/download/Add_Users_CSV.csv">Download</a></td>
          </tr>
        </tbody>
      </table>
    </div>
    <hr class="bottom-hr" />
    <div class="line-footer text-right">
      <button type="button" aria-label="Continue." [disabled]="continueFlag" class="btn btn-secondary btn-sm-block pull-right"
        (click)="continue()">Continue</button>
      <a href="javascript:void(0)" class="btn btn-link btn-sm-block" (click)="cancel()">Cancel</a>
    </div>
  </div>
</div>